<template>
  <!-- 区域选择 -->
  <div class="Area-Select">
    <div style="display: flex" class="top">
      <h1>请选择接单区域</h1>
      <a @click="selectArea()">点击选择区域</a>
    </div>
    <div class="showArea">
      <el-tag v-for="tag in tags" @close="handleClose(tag)" :key="tag.nameCn" closable type="info">
        {{tag.nameCn}}
      </el-tag>
    </div>

    <!-- 打开区域所对应的弹框选择 -->
    <el-dialog class="productTypeDialog" title="提示" :close-on-click-modal="false" custom-class="customProduct" :visible.sync="placeTypeShow" width="25%">
      <div class="dialog-top">
        <span>接单区域选择</span>
      </div>
      <div class="product-checkBox" style="padding-right: 10px;display: flex;flex-direction: column;justify-content: center;">
        <el-radio-group v-model="placeType" style="margin-bottom: 15px;">
          <el-radio :label="0">国家</el-radio>
          <el-radio :label="1">城市</el-radio>
          <el-radio :label="2">区域</el-radio>
          <el-radio :label="3">省份</el-radio>
          </el-radio>
        </el-radio-group>
        <el-select v-model="checkPlace" multiple filterable remote reserve-keyword collapse-tags style="width: 97%;" placeholder="请输入关键词" @focus="remotePlaceMethod('')" :remote-method="remotePlaceMethod">
          <el-option v-for="item in placeOptions" :key="item.pid" :label="item.nameCn" :value="JSON.stringify(item)">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="placeTypeShow = false">取 消</el-button>
        <el-button type="primary" @click="handleSelectPlace()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import Api from "@/components/Api/index"
  import { mapState } from 'vuex'
  import { unique } from '@/assets/utils/ListTool'
  import * as Lodash from 'lodash';
  export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
      return {
        tags: [],
        placeTypeShow: false,
        placeType: 0,
        placeOptions: [],
        checkPlace: []
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      'supplierBasics': {
        handler(value) {
          this.tags = []
          value.areaSelect.forEach(item => {
            this.tags.push({
              nameCn: item.nameCn,
              nameEn: item.nameEn,
              type: item.type,
              pid: item.linkId || item.pid,
              id: item.id
            })
          })
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      selectArea() {
        this.placeTypeShow = true
        this.checkPlace = []
      },
      handleClose(tag) {
        console.log('tags', this.tags)
        if (tag.id != undefined && tag.id !== '') {
          this.$confirm('如删除此地区将不会收到接单提醒, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            new Api("user").customizerAreaDel(tag.id).then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                let index = this.tags.findIndex(u => u.nameCn == tag.nameCn)
                this.tags.splice(index, 1);
              }
            }).catch(() => {
              this.$message({
                type: 'error',
                message: '系统异常!'
              });
            })
          })
        }
        else {
          let index = this.tags.findIndex(u => u.nameCn == tag.nameCn)
          this.tags.splice(index, 1);
        }
        this.$store.commit('setAreaSelect', this.tags)
      },
      handleSelectPlace() {
        let datas = [...this.checkPlace.map(x => JSON.parse(x))]
        const _allDatas = [...datas, ...this.tags]
        const _uniqueData = unique(_allDatas, 'nameCn')
        _uniqueData.forEach(item => {
           let _find = this.tags.find(x => x.nameCn === item.nameCn)
           if (_find) {
              item.id = _find.id
           }
        })
        this.$store.commit('setAreaSelect', _uniqueData)
        this.placeTypeShow = false
      },
      remotePlaceMethod(queryString) {
        new Api('resource').placeList({
          page: 1,
          size: 25,
          q: {
            key: queryString || '',
            type: this.placeType
          }
        }).then(res => {
          if (res.status == 200) {
            this.placeOptions = res.data.records;
          } else {
            this.$message.error({
              message: res.statusText
            })
          }
        })
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  .showArea {
    margin-top: 10px
  }

  .el-tag {
    margin-right: 5px;
    font-size: 14px;
  }

  .top {
    >a {
      display: flex;
      align-items: center;
      margin-left: 10px;
      margin-top: 5px;
      text-decoration: underline;
      color: #DB4E1A
    }

    >a:hover {
      cursor: pointer;
    }
  }

  .productTypeDialog /deep/.el-dialog__header {
    display: none;
  }

  .productTypeDialog /deep/.dialog-top {
    width: 100%;
    background: var(--color);
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-radius: 0.2rem 0.2rem 0 0;
    font-size: 14px;
  }

  .productTypeDialog /deep/.el-dialog__body {
    padding: 0;
  }

  .productTypeDialog /deep/.el-checkbox {
    width: 0.7rem;
    line-height: 2;
  }

  .productTypeDialog /deep/.product-checkBox {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>